(function ($, window, document, viewport, undefined) {

    window.THF = window.THF || {};
    window.THF.Interface = window.THF.Interface || {};
    window.THF.Interface.IFrame = function (options) {
        var defaults = {
            container: '.iframe iframe'
        };
        options = $.extend(true, {}, defaults, options);

        var $container = $(options.container);

        function __construct() {
            if (viewport.is('xs')) {
                updateIFrame('xs');
            }

            if (viewport.is('>=sm')) {
                updateIFrame('sm');
            }

            bindEvents();

            // fix for mobile safari expanding iframe to fit content
            var ios = window.navigator.userAgent.match(/(iPod|iPhone|iPad)/);

            $container.each(function() {
                $(this).attr('scrolling', ios ? 'no' : 'yes');
                
                if(ios) {
                    $(this).parent('.iframe').addClass('ios');
                }
                else {
                    $(this).parent('.iframe').removeClass('ios');
                }
            })
        }

        function bindEvents() {
            $(window).resize(
                viewport.changed(function () {
                    if (viewport.is('xs')) {
                        updateIFrame('xs');
                    } else if (viewport.is('>=sm')) {
                        updateIFrame('sm');
                    }
                })
            );
        }

        function updateIFrame(size) {
            $container.each(function () {
                var updateIFrameUrl = true;
                var currentElem = $(this);
                var url = currentElem.attr('data-' + size + '-url');
                var height = parseInt(currentElem.attr('data-' + size + '-height'), 10);

                if (height === 0) {
                    height = parseInt(currentElem.attr('height'),10);
                }

                // If there is no URL to be changed to or the url
                // is the same, then there is no need to update it.
                if (url !== "" && url !== currentElem.attr('src')) {
                    currentElem.attr('src', url);
                }
                currentElem.attr('height', height);
            });

        }

        __construct();
    };
})(jQuery, window, document, ResponsiveBootstrapToolkit);
